import { Card, Flex, Image, Text } from '@chakra-ui/react';
import { Button } from 'ui-components/dist/Button';
import { EnvelopeIcon } from 'ui-components/dist/EnvelopeIcon';
import { InviteCreatorModalContainer } from '~/components/InviteCreatorModal';
import { useUniqueDisclosure } from '~/hooks/useUniqueDisclosure';

export const InviteCreatorEmptyResults: React.FC = () => {
  const inviteCreatorDisclosure = useUniqueDisclosure();

  const handleInvitreCreatorModalOpen = () => {
    inviteCreatorDisclosure.onOpen();
  };

  return (
    <>
      <Flex alignItems="center" justifyContent="center">
        <Card
          display="flex"
          alignItems="center"
          justifyContent="center"
          maxWidth="30rem"
          borderRadius="1.25rem"
          boxShadow="invitationCard"
        >
          <Image src="/images/empty_creators.png" alt="empty-image" />
          <Text
            fontSize="2xl"
            fontWeight="medium"
            color="primary.700"
            marginTop={5}
          >
            Email an invitation to your talent
          </Text>
          <Text fontSize="lg" color="primary.300" marginTop={1}>
            You can start using Foam once your talent connects to your account
          </Text>
          <Button
            sx={{
              marginTop: 5,
              marginBottom: 7,
            }}
            onClick={handleInvitreCreatorModalOpen}
          >
            <EnvelopeIcon boxSize={4} marginRight={1} />
            Invite via email
          </Button>
        </Card>
      </Flex>
      <InviteCreatorModalContainer
        inviteCreatorDisclosure={inviteCreatorDisclosure}
      />
    </>
  );
};
